import {
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  IconButton,
  styled,
  type DialogTitleProps as MuiDialogTitleProps,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const TituloRaiz = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  position: 'relative',
  paddingRight: theme.spacing(7),
}))

export interface DialogTitleProps extends MuiDialogTitleProps {
  onClose?: () => void
}

export function DialogTitle({ children, onClose, ...outros }: DialogTitleProps): JSX.Element {
  return (
    <TituloRaiz {...outros}>
      {children}

      {onClose && (
        <IconButton
          aria-label="Fechar"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </TituloRaiz>
  )
}

export const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
}))

export const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
}))
